import { useRef } from 'react';
import { type CancelablePromise } from '@upsales/components/Utils/CancelablePromise';
import { useAppDispatch, useSelector } from 'App/components/hooks';
import {
	setCacheData,
	setCachePromise,
	clearCache,
	clearCachePromise,
	getCacheData,
	getCachePromise,
	isCacheValid
} from 'Store/reducers/ExternalIntegrationReducer';

export const useParagonCache = <T>(cacheKey: string) => {
	const dispatch = useAppDispatch();
	const cacheRef = useRef<string>(cacheKey);
	const state = useSelector((state: any) => state.ExternalIntegration);

	const isCacheValidFn = (): boolean => {
		return isCacheValid(state, cacheRef.current);
	};

	const clearCacheFn = () => {
		dispatch(clearCache(cacheRef.current));
	};

	const clearCachePromiseFn = () => {
		dispatch(clearCachePromise(cacheRef.current));
	};

	const getCacheDataFn = (): T | null => {
		return getCacheData(state, cacheRef.current);
	};

	const getCachePromiseFn = (): CancelablePromise<T> | null => {
		return getCachePromise(state, cacheRef.current);
	};

	const setCacheDataFn = (data: T) => {
		dispatch(setCacheData(cacheRef.current, data));
	};

	const setCachePromiseFn = (promise: CancelablePromise<T>) => {
		dispatch(setCachePromise(cacheRef.current, promise));
	};

	return {
		isCacheValid: isCacheValidFn,
		clearCache: clearCacheFn,
		clearCachePromise: clearCachePromiseFn,
		getCacheData: getCacheDataFn,
		getCachePromise: getCachePromiseFn,
		setCacheData: setCacheDataFn,
		setCachePromise: setCachePromiseFn
	};
};
